import script from "./FlareNetworkIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./FlareNetworkIcons.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__